/**
 * 去新知识培训页面站点
 */

const routeMap = {
  'https://www.plantmate.com': 'https://study.plantmate.com',
  'https://plantmate.com': 'https://study.plantmate.com',
  'https://uat2-plantmate.supcon.com:8888':
    'https://uat2study-plantmate.supcon.com:8888',
  'http://uat.plantmate.supcon.com:8888':
    'http://uatstudy.plantmate.supcon.com:8888',
  'http://predev.plantmate.supcon.com:8888':
    'http://predevstudy.plantmate.supcon.com:8888',
  'http://pretest.plantmate.supcon.com:8888':
    'http://preteststudy.plantmate.supcon.com:8888'
}

export function goStudy () {
  if (routeMap[location.origin]) {
    window.open(routeMap[location.origin])
  }
}

// 单独登录跳转到study
export function toStudy (url) {
  if (routeMap[location.origin]) {
    window.location.href = routeMap[location.origin] + url
  }
}

/**
 * 去新知识培训页面站点
 */
export function isStudy (route) {
  const studyRouteList = [
    'courseList',
    'knowledge',
    'knowledgeSearchPage',
    'expertIndex',
    'askExpertIndex',
    'askToExpert',
    'chooseExpert',
    'categoryArticle',
    'exportDetail',
    'postsDetail',
    'onlineTraining',
    'postBarList',
    'questionInfo',
    'toAsk',
    'community',
    'ExpertsQuestion',
    'PostBar',
    'bookList',
    'bookinfo',
    'reviewbook',
    'bookDocList',
    'bookDocDetail',
    'trainTrendList',
    'trainTrendInfo',
    'courseDetail',
    'knowledgeVideoList',
    'knowledgevideoDetil',
    'teacherList',
    'teacherInfo',
    'dataList',
    'dataDetail',
    'certificateList',
    'livenoticeList',
    'onLineSignUp',
    'startExam',
    // 个人中心
    'DailyBonus',
    'ShopCart',
    'examList',
    'myAnswer',
    'myInvitation',
    'buyInvite',
    'myCoupon',
    'myBought',
    'myStudy',
    'CourseHistory',
    'studyStatistics',
    'liveTraining',
    'mySubscribe',
    // 'myCollection',
    'myUpload',
    'myDownload',
    'myComment',
    'myEvaluate',
    'myQuestions',
    'myAdvice'
  ]
  // 本地环境可继续跳转
  if (location.origin.includes('localhost')) {
    return false
  }
  if (route && route.name && studyRouteList.includes(route.name)) {
    goStudy()
    return true
  } else {
    return false
  }
}
